import { render, staticRenderFns } from "./RatePlanNameLink.vue?vue&type=template&id=3c53ca18&"
import script from "./RatePlanNameLink.vue?vue&type=script&lang=js&"
export * from "./RatePlanNameLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports